<template>
    <b-card>
        <load-spinner :loading="isLoading" />
        <h2>Induction Form</h2>
        <div v-if="!questions || !answers">
            <p>No Questions at this time</p>
        </div>
        <div v-else>
            <b-form-group
                v-for="q in questions"
                :key="`label-${q.id}`"
                :label="q.question"
            >
                <b-form-radio-group
                    :id="`answer-${q.id}`"
                    v-model="answers[q.id].answer"
                    :options="yesNo"
                    :disabled="completed"
                    size="lg"
                    @change="saveAnswers"
                />
            </b-form-group>
        </div>
        <div>
            <strong>Student Signature</strong>
        </div>
        <div
            v-if="mutableStudent.induction_signature"
            v-html="mutableStudent.induction_signature"
        />
        <div
            v-else
        >
            <b-btn
                v-b-modal.appSign
                variant="primary"
                size="lg"
                :disabled="!allYesses"
            >
                <!-- <i class="fas fa-pen-fancy" />  -->Sign
            </b-btn>
        </div>
        <b-alert
            class="mt-4"
            variant="success"
            :show="completed"
        >
            Induction Completed
        </b-alert>
        <b-modal
            id="appSign"
            title="Student Signature"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            @ok="studentSign"
            @cancel="clearAll"
        >
            <b-form-group
                label="Student Name"
                label-for="appName"
            >
                <b-form-input
                    id="appName"
                    type="text"
                    :value="student.first_name + ' ' + student.last_name"
                    disabled
                />
            </b-form-group>

            <signature-pad-component
                v-model="induction_signature"
                signature-type="appSig"
            />
        </b-modal>
    </b-card>
</template>

<script>
import SignaturePadComponent from './SignaturePadComponent.vue';

export default {
    components: {
        SignaturePadComponent,
    },
    props: {
        student: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answers: null,
            questions: null,
            yesNo: [
                { text: 'Yes', value: '1' },
            ],
            isLoading: false,
            mutableStudent: this.student,
            induction_signature: '',
        };
    },
    computed: {
        completed() {
            return this.mutableStudent.induction_signed_at !== null;
        },
        allYesses() {
            for (const ans in this.answers) {
                if (this.answers[ans].answer !== '1') {
                    return false;
                }
            }
            return true;
        },
    },
    watch: {
        questions() {
            this.fetchAnswers();
        },
    },
    mounted() {
        this.fetchQuestions();
    },
    methods: {
        studentSign(evt) {
            if (this.student.induction_sign === '') {
                evt.preventDefault();
                return;
            }
            this.isLoading = true;
            axios
                .put(`/api/inductionAnswers/${this.student.id}`, {
                    induction_signature: this.induction_signature,
                })
                .then((res) => {
                    this.clearAll();
                    this.mutableStudent = res.data.data;
                    this.isLoading = false;
                })
                .catch((err) => {
                    new Noty({
                        text: err.response ? err.response.data.error : 'Error saving signature',
                        type: 'error',
                    }).show();
                    this.isLoading = false;
                });
        },
        clearAll() {
            this.induction_signature = '';
        },
        fetchQuestions() {
            this.isLoading = true;
            axios.get('/api/inductionQuestions')
                .then((res) => {
                    this.isLoading = false;
                    this.questions = res.data.data;
                })
                .catch(() => {
                    const n = new Noty({
                        text: 'Error fetching questions',
                        type: 'error',
                    });
                    n.show();
                    this.isLoading = false;
                });
        },
        fetchAnswers() {
            this.isLoading = true;
            axios.get('/api/inductionAnswers', {
                params: {
                    student_id: this.student.id,
                },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.answers = this.createAnswers(res.data.data, this.questions);
                })
                .catch(() => {
                    const n = new Noty({
                        text: 'Error fetching answers',
                        type: 'error',
                    });
                    n.show();
                    this.isLoading = false;
                });
        },
        saveAnswers() {
            this.isLoading = true;
            axios.put('/api/inductionAnswers', {
                answers: this.answers,
                student_id: this.student.id,
            })
                .then((res) => {
                    this.isLoading = false;
                })
                .catch(() => {
                    const n = new Noty({
                        text: 'Error saving answers',
                        type: 'error',
                    });
                    n.show();
                    this.isLoading = false;
                });
        },
        createAnswers(answers, questions) {
            let newObj = {};
            questions.forEach((q) => {
                // look for answer available
                let a = answers.find((a) => a.online_induction_question_id == q.id);
                newObj[q.id] = {
                    answer: a ? a.answer : '0',
                };

            });
            return newObj;
        },
    },
};

</script>
